import React, { Component } from 'react'
import { Link } from 'react-router'
import { findDOMNode } from 'react-dom'
import isEqual from 'lodash.isequal'
import mousetrap from 'mousetrap'
import screenfull from 'screenfull'

import PhotoSwipe from 'photoswipe'
import PhotoSwipeUI from 'photoswipe/dist/photoswipe-ui-default'
import 'photoswipe/dist/photoswipe.css'
import 'photoswipe/dist/default-skin/default-skin.css'

import classNames from './Gallery.css'
import Thumbnail from './Thumbnail'
import ImageMenu from '../image/ImageMenu'
import ImageFavouriteButton from '../image/ImageFavouriteButton'
import ImageFlagButton from '../image/ImageFlagButton'
import Stars from '../Stars'
import ErrorMessage from '../ErrorMessage'
import Modal from '../modals/Modal'
import ImagePage from '../../pages/Image'
import { getEventTitle } from '../../utils/string'

import { DOUBLE_TAP_ZOOM_LEVEL } from '../../constants'

export default class Gallery extends Component {
  static defaultProps = {
    selectedImages: [],
    showInfoLink: true
  }
  state = {
    openImage: null,
    openInfo: null,
    showControls: true
  }
  componentDidMount () {
    if (window.location.search === '?expand') {
      this.openPhotoSwipe(0)
    }
    mousetrap.bind('left', this.hideControls)
    mousetrap.bind('right', this.hideControls)
  }
  shouldComponentUpdate (nextProps, nextState) {
    const { images, selectedImages, selectImageMode, reorderImageMode, entities, thumbSize } = this.props
    const { openImage, openInfo, showControls } = this.state
    if (
      openImage !== nextState.openImage ||
      openInfo !== nextState.openInfo ||
      showControls !== nextState.showControls ||
      selectedImages.length !== nextProps.selectedImages.length ||
      selectImageMode !== nextProps.selectImageMode ||
      reorderImageMode !== nextProps.reorderImageMode ||
      thumbSize !== nextProps.thumbSize
    ) {
      return true
    }
    if (!images && nextProps.images || images && !nextProps.images) {
      return true
    }
    if (images && nextProps.images) {
      if (images.length !== nextProps.images.length) {
        return true
      }
      for (let i = 0; i !== images.length; i++) {
        if (images[i]._id !== nextProps.images[i]._id) {
          return true
        }
      }
    }
    // Update if image rating/flag changes
    if (nextState.openImage) {
      const image = entities.images[nextState.openImage._id]
      const nextImage = nextProps.entities.images[nextState.openImage._id]
      if (!isEqual(image, nextImage)) {
        return true
      }
    }
    return false
  }
  componentDidUpdate (prevProps) {
    const { images, getImageSource } = this.props
    const newImageCount = prevProps.images && images && images.length - prevProps.images.length
    if (this.photoswipe && this.state.openImage) {
      if (newImageCount > 0) {
        // Images have been added
        const items = getItems(images, getImageSource)
        for (let i = prevProps.images.length; i !== images.length; i++) {
          this.photoswipe.items.push(items[i])
        }
        this.photoswipe.ui.update()
      }
      if (newImageCount < 0) {
        // Images have been removed
        this.photoswipe.close()
      }
    }
  }
  componentWillUnmount () {
    mousetrap.unbind(['left', 'right'])
  }
  openPhotoSwipe = index => {
    const { images, getImageSource } = this.props
    const pswp = findDOMNode(this).querySelector('.pswp')
    const items = getItems(images, getImageSource)
    const options = {
      index,
      galleryPIDs: true,
      zoomEl: false,
      fullscreenEl: false,
      shareEl: false,
      showHideOpacity: true,
      history: false,
      getThumbBoundsFn: function () {},
      getDoubleTapZoom: function (isMouseClick, item) {
        return item.initialZoomLevel * DOUBLE_TAP_ZOOM_LEVEL
      },
      timeToIdle: null,
      barsSize: { top: 44, bottom: 64 }
    }
    this.setState({
      openImage: images[index]
    })
    this.photoswipe = new PhotoSwipe(pswp, PhotoSwipeUI, items, options)
    this.photoswipe.listen('beforeChange', () => {
      const { images, loadMoreImages } = this.props
      const index = this.photoswipe.getCurrentIndex()
      if (loadMoreImages && images.length - index <= 3) {
        loadMoreImages()
      }
      this.setState({
        openImage: images[index]
      })
    })
    this.photoswipe.listen('close', () => {
      this.setState({
        openImage: null,
        openInfo: null
      })
      if (screenfull.isFullscreen) {
        screenfull.exit()
      }
    })
    this.photoswipe.init()
    this.photoswipe.framework.bind(this.photoswipe.scrollWrap, 'pswpTap', e => {
      if ('ontouchstart' in window) {
        this.setState({
          // Do not use ! here because the --hidden class hasn't been set by photoswipe yet
          showControls: pswp.querySelector('.pswp__ui').classList.contains('pswp__ui--hidden')
        })
      }
    })
    this.photoswipe.framework.bind(this.photoswipe.scrollWrap, 'click', this.showControls)
  }
  onClickInfo = id => {
    this.setState({ openInfo: id })
  }
  onCloseInfo = () => {
    this.setState({ openInfo: null })
  }
  hideControls = () => {
    if (this.state.openImage) {
      this.setState({ showControls: false })
      this.photoswipe && this.photoswipe.ui.setIdle(true)
    }
  }
  showControls = () => {
    this.setState({ showControls: true })
    this.photoswipe && this.photoswipe.ui.setIdle(false)
  }
  onClickFullscreen = () => {
    screenfull.toggle()
    this.hideControls()
  }
  // TODO: Should this be moved to redux logic?
  reorderImages = index => {
    const { images, selectedImages, updateManualOrder } = this.props

    const ids = images.map(image => image._id)

    // Create array with selected images removed
    const order = ids.filter(id => selectedImages.indexOf(id) === -1)

    // Insert selected image array at adjusted index
    order.splice(index, 0, ...selectedImages)

    updateManualOrder(order)
  }
  renderThumbnail = (image, index) => {
    const {
      getImageSource,
      selectImageMode,
      reorderImageMode,
      selectedImages,
      selectImage,
      deselectImage,
      anonymousUser,
      showInfoLink,
      enableEditing,
      confirmReorder,
      thumbSize
    } = this.props
    const id = image._id
    const selected = selectedImages.indexOf(id) !== -1
    const onClick = () => {
      if (reorderImageMode) {
        if (!confirmReorder || window.confirm('This will override the existing manual order. Are you sure you want to do this?')) {
          this.reorderImages(index)
        }
        return
      }
      if (selectImageMode) {
        if (selected) {
          deselectImage(id)
        } else {
          selectImage(id)
        }
        return
      }
      if ('activeElement' in document && document.activeElement.tagName === 'INPUT') {
        document.activeElement.blur() // Ensure soft keyboard is hidden
        setTimeout(() => {
          this.openPhotoSwipe(index)  // Delay opening until soft keyboard is hidden
        }, 300)
      } else {
        this.openPhotoSwipe(index)
      }
    }
    const onPress = () => {
      if (this.props.canEdit) {
        enableEditing()
      }
      selectImage(id)
    }
    return (
      <Thumbnail
        key={id}
        id={id}
        src={getImageSource(id, thumbSize > 240 ? 'd' : 't')}
        selected={selected}
        selectImageMode={selectImageMode}
        reorderImageMode={reorderImageMode}
        onClick={onClick}
        onPress={onPress}
        showInfoLink={showInfoLink && !anonymousUser}
        onClickInfo={() => {
          onClick()
          this.onClickInfo(id)
        }}
        size={thumbSize}
      />
    )
  }
  renderImages (images) {
    const { showEventHeadings, userLibraries } = this.props
    const nodes = []
    let previous
    for (let i = 0; i !== images.length; i++) {
      const image = images[i]
      if (showEventHeadings && (!previous || previous._event !== image._event)) {
        nodes.push(
          <h2 key={image._event} className={classNames.heading}>
            <Link to={`/album?path=${image._event}`}>
              {getEventTitle(image._event, userLibraries)}
            </Link>
          </h2>
        )
      }
      nodes.push(this.renderThumbnail(image, i))
      previous = image
    }
    return nodes
  }
  render () {
    const { images, getImageSource, setCover, anonymousUser, title, showInfoLink } = this.props
    const { openImage, openInfo } = this.state
    return (
      <div>
        {images && images.length === 0 &&
          <ErrorMessage message='No images found' />
        }
        {images && images.length !== 0 &&
          <ul className={classNames.thumbnails} style={this.props.style}>
            {this.renderImages(images)}
          </ul>
        }
        <PhotoSwipeMarkup title={title} />
        {openImage &&
          <div className={this.state.showControls ? classNames.controlsShown : classNames.controlsHidden}>
            {!openInfo && !anonymousUser &&
              <Stars
                className={classNames.stars}
                rating={openImage._rating}
                image={this.props.entities.images[openImage._id]}
                whiteStars
                clickable
              />
            }
            {!openInfo && !anonymousUser &&
              <ImageFavouriteButton id={openImage._id} className={classNames.favButton} />
            }
            {openInfo &&
              <button
                className={classNames.infoOverlay}
                onClick={this.onCloseInfo}
              />
            }
            {openInfo &&
              <Modal style={{ 'top': '44px' }}>
                <ImagePage params={{ id: openInfo }} onClickThumbnail={this.onCloseInfo} />
              </Modal>
            }
            {!anonymousUser &&
              <ImageMenu
                image={openImage}
                getImageSource={getImageSource}
                setCover={setCover}
                showInfoLink={showInfoLink}
                onClickInfo={openInfo ? this.onCloseInfo : () => this.onClickInfo(openImage._id)}
                canShareInternal={this.props.canShareImagesInternal}
                canShareExternal={this.props.canShareImagesExternal}
                onClickFullscreen={this.onClickFullscreen}
                albumID={this.props.albumID}
                images={this.props.images.map(i => i._id)}
                canRemove={this.props.canRemove}
                excludeImages={this.props.excludeImages}
              />
            }
            {!openInfo && this.props.canFlag &&
              <ImageFlagButton id={openImage._id} className={classNames.flagButton} />
            }
          </div>
        }
      </div>
    )
  }
}

function getItems (images, getImageSource) {
  return images.map(image => ({
    pid: image._id,
    src: getImageSource(image._id, 'd'),
    thumbnail: getImageSource(image._id),
    w: image._width,
    h: image._height
  }))
}

// http://photoswipe.com/documentation/getting-started.html#init-add-pswp-to-dom
const PhotoSwipeMarkup = ({ title }) => (
  <div className='pswp' tabIndex='-1' role='dialog' aria-hidden='true'>
    <div className='pswp__bg'></div>
    <div className='pswp__scroll-wrap'>
      <div className='pswp__container'>
        <div className='pswp__item'></div>
        <div className='pswp__item'></div>
        <div className='pswp__item'></div>
      </div>
      <div className='pswp__ui pswp__ui--hidden'>
        <div className='pswp__top-bar'>
          <div className='pswp__counter'></div>
          <div className='pswp__title'>{title}</div>
          <button className='pswp__button pswp__button--close' title='Close (Esc)' />
          <button className='pswp__button pswp__button--share' title='Share' />
          <button className='pswp__button pswp__button--fs' title='Toggle fullscreen' />
          <button className='pswp__button pswp__button--zoom' title='Zoom in/out' />
          <div className='pswp__preloader'>
            <div className='pswp__preloader__icn'>
              <div className='pswp__preloader__cut'>
                <div className='pswp__preloader__donut'></div>
              </div>
            </div>
          </div>
        </div>
        <div className='pswp__share-modal pswp__share-modal--hidden pswp__single-tap'>
          <div className='pswp__share-tooltip'></div>
        </div>
        <button className='pswp__button pswp__button--arrow--left' title='Previous (arrow left)'>
        </button>
        <button className='pswp__button pswp__button--arrow--right' title='Next (arrow right)'>
        </button>
        <div className='pswp__caption'>
          <div className='pswp__caption__center'></div>
        </div>
      </div>
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/gallery/Gallery.js